var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboard = function SvgKeyboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5,
    d: "M5.75 16.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm12.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5ZM5.75 12a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm4 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm4.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm4 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.75 17.25h4.5m-8.5-8.5v-1.5a2.5 2.5 0 0 1 2.5-2.5h8.5a1.5 1.5 0 0 0 1.5-1.5v-.5m-13.5 6h14.5a3 3 0 0 1 3 3v6.5a3 3 0 0 1-3 3H4.75a3 3 0 0 1-3-3v-6.5a3 3 0 0 1 3-3"
  })));
};
export default SvgKeyboard;